export const AdminVersionModelData = function () {
  return {
    feVersion: '',
    beVersion: ''
  }
}
